export default function Ressource(){
    return <div className="flex flex-col min-h-screen">

    </div>
}